<template>
<div>
  <div id="pfm-cart-code-field-group" @click="[initialFocus(), setState('typing')]" :class="{'shake': !isValid}">
    <div class="pfm-cart-input-field" :class="['state-' + state, 'mode-' + mode, {'focused': this.focus.f1}, {'filled': this.filled}, {'error' : !isValid}]">

      <div class='main'>
        <div class='input-wrap' v-show="mode != 'help'">
          <input v-if="['input'].includes(kind)" :id="`${this._uid}-1`" :class="'state-' + state" ref="inputField1" type="text" inputmode="numeric" maxlength="1" :name="`${this._uid}-inputField-${this.name}-1`" :autocomplete="name" tabindex="0"
            spellcheck="false" v-model="code.f1" @click="setFocus(1, $event),setState('typing')" @blur="[setStateAuto(), setDefocus(1, $event)]" @paste="pasteCode" @keyup="valueChanged(1, $event)" :disabled="state == 'progress'">
        </div>
      </div>
    </div>

    <div class="pfm-cart-input-field" :class="['state-' + state, 'mode-' + mode, {'focused': this.focus.f2}, {'filled': this.filled}, {'error' : !isValid}]">

      <div class='main'>
        <div class='input-wrap' v-show="mode != 'help'">
          <input v-if="['input'].includes(kind)" :id="`${this._uid}-2`" :class="'state-' + state" ref="inputField2" type="text" inputmode="numeric" maxlength="1" :name="`${this._uid}-inputField-${this.name}-2`" :autocomplete="name" tabindex="0"
            spellcheck="false" v-model="code.f2" @click="setFocus(2, $event),setState('typing')" @blur="[setStateAuto(), setDefocus(2, $event)]" @keyup="valueChanged(2, $event)" @paste="pasteCode" :disabled="state == 'progress'">
        </div>
      </div>
    </div>

    <div class="pfm-cart-input-field" :class="['state-' + state, 'mode-' + mode, {'focused': this.focus.f3}, {'filled': this.filled}, {'error' : !isValid}]">

      <div class='main'>
        <div class='input-wrap' v-show="mode != 'help'">
          <input v-if="['input'].includes(kind)" :id="`${this._uid}-3`" :class="'state-' + state" ref="inputField3" type="text" inputmode="numeric" maxlength="1" :name="`${this._uid}-inputField-${this.name}-3`" :autocomplete="name" tabindex="0"
            spellcheck="false" v-model="code.f3" @click="setFocus(3, $event),setState('typing')" @blur="[setStateAuto(), setDefocus(3, $event)]" @keyup="valueChanged(3, $event)" @paste="pasteCode" :disabled="state == 'progress'">
        </div>
      </div>
    </div>

    <div class="pfm-cart-input-field" :class="['state-' + state, 'mode-' + mode, {'focused': this.focus.f4}, {'filled': this.filled}, {'error' : !isValid}]">

      <div class='main'>
        <div class='input-wrap' v-show="mode != 'help'">
          <input v-if="['input'].includes(kind)" :id="`${this._uid}-4`" :class="'state-' + state" ref="inputField4" type="text" inputmode="numeric" maxlength="1" :name="`${this._uid}-inputField-${this.name}-4`" :autocomplete="name" tabindex="0"
            spellcheck="false" v-model="code.f4" @click="setFocus(4, $event),setState('typing')" @blur="[setStateAuto(), setDefocus(4, $event)]" @keyup="valueChanged(4, $event)" @paste="pasteCode" :disabled="state == 'progress'">
        </div>
      </div>
    </div>

    <div class="pfm-cart-input-field" :class="['state-' + state, 'mode-' + mode, {'focused': this.focus.f5}, {'filled': this.filled}, {'error' : !isValid}]">

      <div class='main'>
        <div class='input-wrap' v-show="mode != 'help'">
          <input v-if="['input'].includes(kind)" :id="`${this._uid}-5`" :class="'state-' + state" ref="inputField5" type="text" inputmode="numeric" maxlength="1" :name="`${this._uid}-inputField-${this.name}-5`" :autocomplete="name" tabindex="0"
            spellcheck="false" v-model="code.f5" @click="setFocus(5, $event),setState('typing')" @blur="[setStateAuto(), setDefocus(5, $event)]" @keyup="valueChanged(5, $event)" @paste="pasteCode" :disabled="state == 'progress'">
        </div>
      </div>
    </div>

    <div class="pfm-cart-input-field" :class="['state-' + state, 'mode-' + mode, {'focused': this.focus.f6}, {'filled': this.filled}, {'error' : !isValid}]">

      <div class='main'>
        <div class='input-wrap' v-show="mode != 'help'">
          <input v-if="['input'].includes(kind)" :id="`${this._uid}-6`" :class="'state-' + state" ref="inputField6" type="text" inputmode="numeric" maxlength="1" :name="`${this._uid}-inputField-${this.name}-6`" :autocomplete="name" tabindex="0"
            spellcheck="false" v-model="code.f6" @click="setFocus(6, $event),setState('typing')" @blur="[setStateAuto(), setDefocus(6, $event)]" @keyup="valueChanged(6, $event)" @paste="pasteCode" :disabled="state == 'progress'">
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    data: Object,
    name: String,
    kind: String, // input | textarea
    label: String,
    type: String, // email | ...
    isValid: Boolean,
    codeValidationChange: Object
  },
  components: {},
  data() {
    return {
      focus: {
        f1: false,
        f2: false,
        f3: false,
        f4: false,
        f5: false,
        f6: false
      },
      initialFocusWasTriggered: false,
      filled: false,
      state: 'init', // init | typing | progress                          | valid | error | disabled
      mode: 'input', // input | help
      inputValue: '',
      valueOnFocus: '',
      pasteEventInProgress: false,
      // isValid: false,
      code: {
        f1: null,
        f2: null,
        f3: null,
        f4: null,
        f5: null,
        f6: null
      }
    };
  },
  created() {
    console.log('TextField:created', this.name, this.kind, this.data[this.name])
    this.inputValue = this.data[this.name]
    if (this.inputValue) {
      console.log('TYPING', this.inputValue)
      this.filled = true
      this.setState('typing')
    }
    console.log('Value', this.name, this.inputValue)
  },
  watch: {
    inputValue: {
      handler() {
        this.data[this.name] = this.inputValue
      }
    },
    codeValidationChange: {
      deep: true,
      handler() {
        console.log('code validation changed', this.isValid)
        if (this.isValid) {
          this.state = 'typing'
          console.log('changed state', this.state)
        }
      }
    }
  },
  methods: {
    setState(state) {
      // ignore if in progress
      if (this.state != 'progress') {
        this.state = state
      }
    },
    setStateAuto() {
      if (this.inputValue) {
        // VALIDATE HERE
        this.setState('valid')
        this.filled = true
      } else {
        this.setState('typing') // not init, because i already used the field.
        this.filled = false
      }
    },
    setMode(mode) {
      this.mode = mode
    },
    setValueOnFocus() {
      this.selectedAddressFromDropdown = false // reset
      var currentValue = this.$refs[this._uid + '-googleAutocomplete'].autocompleteText
      console.log('setting value on focus', currentValue)
      this.valueOnFocus = currentValue
    },
    initialFocus() {
      if (!this.initialFocusWasTriggered) {
        console.log('initialFocus')
        this.initialFocusWasTriggered = true
        this.setFocus(1)
      }
    },
    setFocus(fieldNumber, event, preventRecursion) {
      console.log('setFocus():', event, fieldNumber)
      
      // ignore if in progress
      if (this.state != 'progress') {
        
      if (fieldNumber) {
        console.log('focusing on field:', fieldNumber)
        this.focus[`f${fieldNumber}`] = true
        this.$refs[`inputField${fieldNumber}`].focus()
        this.$refs[`inputField${fieldNumber}`].setSelectionRange(1, 1) // position caret at the end
        // }
      } else {
        console.log('no fieldNumber specified -> focusing on first field')
        this.$nextTick(() => {
          this.$refs.inputField1.focus()
        })
      }
      }

    },
    pasteCode(event) {
      this.pasteEventInProgress = true
      console.log('pasteCode', event)
      var clipboardData, pastedData
      event.stopPropagation()
      event.preventDefault()
      this.$nextTick(() => {
        clipboardData = event.clipboardData || window.clipboardData
        pastedData = clipboardData.getData('text/plain')
        console.log('pasteCode:', event, pastedData)
        // fill the fields
        if (pastedData.length == 6) {
          for (var i = 1; i <= pastedData.length; i++) {
            this.code[`f${i}`] = pastedData[i - 1]
          }

          // focus on last field
          this.$refs.inputField6.focus()
          this.validateCode()
        }
        this.pasteEventInProgress = false
      })
    },
    getCode() {
      return `${this.code.f1}${this.code.f2}${this.code.f3}${this.code.f4}${this.code.f5}${this.code.f6}`
    },
    validateCode() {
      // validate code
      this.inputValue = this.getCode()
      console.log('validateCode():', this.inputValue)
      this.state = 'progress'
      this.$emit('updated', this.inputValue)
    },
    setDefocus(fieldNumber, event) {
      console.log('setDefocus', fieldNumber, event)
      this.focus[`f${fieldNumber}`] = false
    },
    jumpToField(fieldNumber) {
      if (fieldNumber > 0 && fieldNumber <= 6) {
        console.log('jumping to next field:', fieldNumber, this.$refs[`inputField${fieldNumber}`])
        this.setFocus(fieldNumber, null, true)
      }
    },
    valueChanged(fieldNumber, event) {
      console.log('valueChanged()', fieldNumber, event)

      // ignore if code was pasted
      if (!this.pasteEventInProgress) {
        var key = event.keyCode || event.charCode;

        // backspace was hit
        if (key == 8 || key == 46) {
          console.log('hit escape')
          this.jumpToField(fieldNumber - 1)
          this.$emit('backspacing')
        } else {
          var fieldValue = event.target.value
          // proceed if input was a number 
          var regex = /[0-9]/
          if (regex.test(fieldValue)) {
            console.log('value changed', event, fieldNumber, fieldValue, event.target.id)
            if (fieldValue.length == 1 && fieldNumber < 6) {
              this.jumpToField(fieldNumber + 1)
            } else {
              console.log('this is a last field')

              this.validateCode()
            }
          } else {
            console.log('NaN -> ignoring & erasing field')
            this.code[`f${fieldNumber}`] = null
          }
        }
      }
    },
  }
}
</script>

<style lang='less' scoped>
@import '../../variables.less';

#pfm-cart-code-field-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 0 10px;

    .pfm-cart-input-field {
        border: 1px solid @pfm-cart-color-border;
        border-radius: 7px;
        height: 56px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        transition: background 0.5s, box-shadow 0.2s ease-in-out;
        margin: 0 4px;

        &:hover {
            box-shadow: 0 0 0 1px @pfm-cart-color-border;
        }

        .main {
            flex: 1;
            height: 100%;
            transition: all 0.2s ease-in-out;
            cursor: text;

            .input-wrap {
                height: 100%;

                span.placeholder {}

                input {
                    background: none;
                    border: none;
                    outline: none;
                    font-size: 1.5rem;
                    color: @pfm-cart-color-form-text;
                    // color: transparent;
                    // text-shadow: 0 0 0 @pfm-cart-color-form-text;
                    width: 100%;
                    height: 100%;
                    opacity: 1;
                    text-align: center;

                    &.state-init {
                        opacity: 0;
                        height: 0;
                    }

                    &::placeholder {
                        color: @pfm-cart-color-form-placeholder;
                    }
                    &:-ms-input-placeholder {
                        color: @pfm-cart-color-form-placeholder;
                    }
                    &::-webkit-input-placeholder {
                        color: @pfm-cart-color-form-placeholder;
                    }
                }
            }
        }

        &.focused {
            border-color: @pfm-cart-color-border-focused;
            box-shadow: 0 0 0 1px @pfm-cart-color-border-focused;
            transition: all 0.2s ease-in-out;

            .main {
                transition: all 0.2s ease-in-out;
            }
        }

        &.state-typing {
            .main {}
        }

        &.state-progress {
            .main {
                .input-wrap {
                    input {
                        color: @pfm-color-neutral-500;
                    }
                }
            }
        }

        &.error {
            border-color: @pfm-cart-color-danger;
            box-shadow: 0 0 0 1px @pfm-cart-color-danger;
            transition: all 0.2s ease-in-out;

            .main {}
        }

        &.filled {
            .main {
                .label-wrap {
                    height: auto;
                    label {
                        padding-top: 0;
                        font-size: 0.625rem;
                    }
                }
            }
        }
    }
}
</style>